import { ISearchResult } from '../../state-helpers/search-results';
import * as React from 'react';
import moment from 'moment';
import { trackClick } from '../../actions/track-click';
import * as Redux from 'redux';
import { ISearchAppState } from '../../reducers/index';
import { Lock, hasLock } from './lock'
import { getSourceDomainSVG } from '../../reducers/contexts-model';
import { getIconType } from '../../reducers/results-model';
import { IEpiProps } from '../../state-helpers/epi-props';
import { SearchResultGeneral } from './search-result-general';
import { SearchResultShop } from './search-result-shop';
import { SearchResultBestBet } from './search-result-best-bet';
import { SearchResultMember } from './search-result-member';

export interface IProps {
    result: ISearchResult;
    epiProps: IEpiProps;

    onClick: (hitId) => void;
}

export class SearchResult extends React.Component<IProps, any> {

    render() {
        const { epiProps, result, onClick } = this.props;

        const hitOnClick = () => onClick(result.hitId);

        var searchResultTemplate;
        if (result.resultType === 'Product') {
            searchResultTemplate = <SearchResultShop epiProps={epiProps} result={result} onClick={hitOnClick} />;
        } else if (result.isBestBet) {
            searchResultTemplate = <SearchResultBestBet epiProps={epiProps} result={result} onClick={hitOnClick} />;
        } else if (result.resultType === 'Member') {
            searchResultTemplate = <SearchResultMember epiProps={epiProps} result={result} onClick={hitOnClick} />;
        } else {
            searchResultTemplate = <SearchResultGeneral epiProps={epiProps} result={result} onClick={hitOnClick} />;
        }

        return (
            <div className="search-result-wrapper">
                {searchResultTemplate}
            </div>
        )
    }
}